import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

import {
    RouteModuleMapping,
    RouteWithUpdateAccess,
    RouteWithWriteAccess,
    RouteWithReadAccess,
    UpdatePermission,
    WritePermission,
    ReadPermission,
} from '@shared/model/permission.model';
import { ROUTE_PATH } from '@shared/enum/common.enum';
import { PermissionService } from '@services/permission.service';

@Injectable({
    providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
    constructor(
        private readonly permissionService: PermissionService,
        private readonly router: Router
    ) {}

    canActivate(
        next: ActivatedRouteSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        const routePath = next.routeConfig?.path as ROUTE_PATH;

        if (!routePath) {
            this.router.navigate([ROUTE_PATH.NOT_FOUND]);
            return false;
        }

        let permissionRequired = ReadPermission;

        if (RouteWithWriteAccess.includes(routePath)) {
            permissionRequired = WritePermission;
        }

        if (RouteWithUpdateAccess.includes(routePath)) {
            permissionRequired = UpdatePermission;
        }

        if (RouteWithReadAccess.includes(routePath)) {
            permissionRequired = ReadPermission;
        }

        const moduleId = RouteModuleMapping[routePath];

        if (!moduleId) {
            this.router.navigate([ROUTE_PATH.NOT_FOUND]);
            return false;
        }

        const hasPermission = this.permissionService.hasPermission(
            moduleId,
            permissionRequired
        );

        if (hasPermission) {
            return true;
        } else {
            this.router.navigate([ROUTE_PATH.NOT_FOUND]);
            return false;
        }
    }
}
